module.exports = __webpack_public_path__ + "static/media/boat-img-8.fb0c908f.jpg";